<template>
  <div class="extra-sidebar-container" :class="{ on: childrenMenu.length }">
    <el-menu :default-active="activeMenu" router>
      <el-menu-item
        v-for="menuItem in childrenMenu"
        :key="menuItem.id"
        :index="menuItem.viewDirectUrl"
      >
        <span>{{ generateTitle(menuItem.viewTitle) }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { getMenuChildApi } from '@/api/auth_service/authManage'
import { generateTitle } from '@/utils/i18n'

export default {
  data() {
    return {
      childrenMenu: []
    }
  },
  computed: {
    menuLink() {
      return this.$store.getters['app/getSidebarMenuLink']
    },
    activeMenu() {
      return this.$route.path
    }
  },
  watch: {
    menuLink: {
      immediate: true,
      handler(val) {
        if (val) {
          this.fnGetChildrenMenu()
        } else {
          this.childrenMenu = []
        }
      }
    }
  },
  methods: {
    async fnGetChildrenMenu() {
      await getMenuChildApi({
        view_direct_url: this.menuLink
      }).then(res => {
        this.childrenMenu = res.data
      })
    },
    generateTitle
  }
}
</script>

<style lang="scss">
/* .app-main {
  padding-left: 258px;
  width: auto !important;
}

#fixed {
    position: fixed;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  } */
</style>
